import { render, staticRenderFns } from "./ForceChangePassword.vue?vue&type=template&id=fffcd120&scoped=true"
import script from "./ForceChangePassword.vue?vue&type=script&lang=ts"
export * from "./ForceChangePassword.vue?vue&type=script&lang=ts"
import style0 from "./ForceChangePassword.vue?vue&type=style&index=0&id=fffcd120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffcd120",
  null
  
)

export default component.exports